import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { parsePhoneNumberFromString } from 'libphonenumber-js/mobile';
import { setCurrentYear, updateProfile } from '../services/student';
import { showError, showSuccess } from '../Utils/helper';
import { UserContext } from '../context/AuthContext';

function CompleteProfileModal({ closeModal, setShow }) {
    const { t } = useTranslation();
    const { user, refreshUser } = useContext(UserContext);

    const [selectedYear, setSelectedYear] = useState('');
    const [rawMobileNumber, setRawMobileNumber] = useState('');
    const [mobileError, setMobileError] = useState('');
    const yearOptions = ['firstYear', 'secondYear', 'thirdYear', 'fourthYear', 'fifthYear', 'sixthYear', 'seventhYear', 'graduateYear'];

    const needsMobileNumber = !user?.mobile_number;

    async function handleCompleteProfile() {
        if (needsMobileNumber) {
            if (rawMobileNumber.trim().length <= 0) {
                setMobileError(t('common.enterValidMobileNumber', 'Enter a valid mobile number'));
                return;
            }
            const parsed = parsePhoneNumberFromString(`+${rawMobileNumber.replace(/^\+/, '')}`);
            if (!parsed || !parsed.isValid()) {
                setMobileError(
                    t(
                        'common.mobileCountryNotSupported',
                        'Enter a valid mobile number'
                    )
                );
                return;
            }
        }
        setMobileError('');

        try {
            await setCurrentYear({ year: selectedYear });

            if (needsMobileNumber) {
                await updateProfile({
                    first_name: user.first_name,
                    last_name: user.last_name,
                    country_id: user.country_id,
                    mobile_number: `00${rawMobileNumber.replace(/^\+/, '')}`,
                });
                refreshUser();
            }

            showSuccess(t('alertMessage.success'));
            closeModal();
            setShow(false);
        } catch (err) {
            showError(t('alertMessage.wrong'));
        }
    }

    return (
        <div className="lrf_modal">
            <h2>Complete Your Profile</h2>
            <div className="lrf_subtext">
                <p>Kindly select your current year of study{needsMobileNumber && ' and enter your mobile number'}</p>
                <p>الرجاء تحديد السنة الدراسية{needsMobileNumber && ' وإدخال رقم هاتفك'}</p>
            </div>
            <div className="lrf_subtext">
                <select
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                    className="react_select"
                    style={{
                        paddingLeft: '30px',
                        paddingRight: '28px',
                        paddingTop: '10px',
                        paddingBottom: '10px',
                    }}
                >
                    <option value="" disabled>
                        Select a year
                    </option>
                    {yearOptions.map((year, index) => (
                        <option key={index} value={year}>
                            {t('year.' + year, year)}
                        </option>
                    ))}
                </select>
                {needsMobileNumber && (
                    <div className="mt-3">
                        <label>{t('common.mobileNumber')}</label>
                        <PhoneInput
                            country={'kw'}
                            countryCodeEditable={false}
                            value={rawMobileNumber}
                            onChange={(phone) => {
                                setRawMobileNumber(phone);
                                setMobileError('');
                            }}
                            inputStyle={{ width: '100%' }}
                        />
                        {mobileError && <p style={{ color: 'red', marginTop: '5px' }}>{mobileError}</p>}
                    </div>
                )}
                <div>
                    <button className="btn_primary big_btn full_btn mt-3" onClick={handleCompleteProfile}>
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CompleteProfileModal;
